import React, { Fragment } from "react";
import BlockUi from "react-block-ui";
import { Loader } from "react-loaders";
import { Link } from "react-router-dom";
import { Col, Form, Row } from "reactstrap";
import bg4 from "../assets/architect/utils/images/originals/bg_white.jpg";
import picLogo from "../assets/architect/utils/images/originals/pic_logo.png";
import CostumForm from "../common/Form/form";
import * as UsersService from "../services/users/api_user";

class Register extends CostumForm {
  constructor(props) {
    super(props);
    this.state = {
      blocking: false,
      credentials: {
        email: "",
        password: "",
        repeatPassword: "",
        name: "",
      },
      errors: {},
    };
  }

  /*********************************** LIFECYCLE ***********************************/
  componentDidMount() {
    this._isMounted = true;

    const user = UsersService.getCurrentUser();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  /*********************************** HANDLERS ***********************************/

  doSubmit = async (e) => {
    e.preventDefault();
    const errors = { ...this.state.errors };

    const { credentials } = this.state;

    const { data } = await UsersService.register(credentials);

    if (data.error) {
      errors.email = data.error;
      this.setState({ errors });
    } else {
      alert(
        "Please wait for the confirmation of the admin to login. Thank you!"
      );
      window.location = "/";
    }
  };
  /*********************************** API ***********************************/

  render() {
    
    return (
      <Fragment>
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={<Loader active type="line-scale-pulse-out" />}
        >
          <div className="h-100 bg-animation">
            <div
              className="d-flex h-100 justify-content-center align-items-center"
              style={{
                background: "url(" + bg4 + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }}
            >
              <Col md="8" className="mx-auto app-login-box">
                <div
                  className="modal-dialog w-100 mx-auto"
                  style={{
                    boxShadow: "0px 1px 10px 0px rgba(52, 58, 64, 0.3)",
                  }}
                >
                  <div className="modal-content" style={{ border: "none" }}>
                    <div className="modal-body" style={{ padding: "2.5rem" }}>
                      <div className="h6 modal-title text-center mb-4">
                        <img
                          className="mb-4"
                          src={picLogo}
                          alt="Company logo"
                          style={{ height: "100px", width: "auto" }}
                        />
                        <p>PICAdvanced Client Management Platform</p>
                      </div>
                      <Form onSubmit={this.doSubmit}>
                        <Row form>
                          <Col md={6}>
                            {this.renderInput(
                              "email",
                              "email",
                              "Email",
                              "Email here..."
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderInput(
                              "name",
                              "text",
                              "Name",
                              "Name here..."
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderInput(
                              "password",
                              "password",
                              "Password"
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderInput(
                              "repeatPassword",
                              "password",
                              "Repeat Password",
                              "Repeat Password here..."
                            )}
                          </Col>
                        </Row>

                        <div className="mt-4 d-flex align-items-center">
                          <h5 className="mb-0">
                            Already have an account?{" "}
                            <Link to="/login" className="text-primary">
                              Sign in
                            </Link>
                          </h5>
                          <div className="ml-auto">
                            {this.renderButton("Register")}
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="text-center text-black opacity-8 mt-3">
                  Copyright &copy; PICAdvanced {new Date().getFullYear()}
                </div>
              </Col>
            </div>
          </div>
        </BlockUi>
      </Fragment>
    );
  }
}
export default Register;



// WEBPACK FOOTER //
// ./src/User/Register.js